import { createAction, props } from '@ngrx/store';
export const setReportType = createAction('[Custom PDF Report Builder] Set Report Type', props());
